import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import { Button } from "@/components/ui/button";

export function ThemeToggle({ showText = true }) {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size={showText ? "default" : "icon"}
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className={`relative ${showText ? 'w-full flex items-center p-3 rounded-lg hover:bg-accent' : 'h-10 w-10 hover:bg-accent'}`}
    >
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      {showText && <span className="ml-4 whitespace-nowrap">Changer de thème</span>}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
